import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-429df78c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  t: "1666264624575",
  class: "icon",
  viewBox: "0 0 1024 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "2550",
  width: "200",
  height: "200"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M864 445.866667c0 0 0 2.133333 0 2.133333 0 0 0 2.133333 0 2.133333 0 2.133333 0 2.133333 0 4.266667 0 0 0 2.133333 0 2.133333L789.333333 855.466667c-2.133333 4.266667-4.266667 8.533333-6.4 10.666667 0 0 0 0 0 0-2.133333 2.133333-4.266667 2.133333-6.4 4.266667-2.133333 0-2.133333 2.133333-4.266667 2.133333-2.133333 0-2.133333 0-4.266667 0 0 0-2.133333 0-2.133333 0L311.466667 872.533333l-17.066667 0-85.333333 0c-27.733333 0-49.066667-21.333333-49.066667-49.066667L160 450.133333c0-27.733333 21.333333-46.933333 49.066667-46.933333l102.4 0L311.466667 405.333333c91.733333-6.4 164.266667-78.933333 168.533333-170.666667l2.133333 0c0-4.266667-2.133333-6.4-2.133333-10.666667C480 183.466667 514.133333 149.333333 554.666667 149.333333s74.666667 34.133333 74.666667 74.666667c0 4.266667 0 6.4-2.133333 10.666667l2.133333 0c0 0 0 0 0 0 0 70.4-21.333333 136.533333-57.6 189.866667l268.8 0c2.133333 0 4.266667 0 4.266667 0 0 0 0 0 0 0 0 0 0 0 0 0 2.133333 0 6.4 2.133333 8.533333 4.266667 0 0 0 0 0 0 2.133333 2.133333 4.266667 4.266667 6.4 6.4 0 0 0 0 0 2.133333C861.866667 439.466667 864 441.6 864 445.866667zM266.666667 450.133333 204.8 450.133333 204.8 832l61.866667 0L266.666667 450.133333zM518.4 424.533333 518.4 424.533333c44.8-51.2 70.4-117.333333 70.4-189.866667l-2.133333 0c2.133333-4.266667 2.133333-6.4 2.133333-10.666667C586.666667 206.933333 573.866667 192 554.666667 192s-32 14.933333-32 32c0 4.266667 0 6.4 2.133333 10.666667l-2.133333 0c-4.266667 115.2-96 206.933333-211.2 213.333333l0 384 433.066667 0L810.666667 469.333333 518.4 469.333333c-12.8 0-25.6-4.266667-25.6-19.2C492.8 437.333333 503.466667 424.533333 518.4 424.533333z",
    "p-id": "2551"
  })
], -1))
const _hoisted_2 = { key: 0 }

import { request } from '@/utils';
  import { IArticle, getArticleDefaultData } from '@/types/article';

  interface IProps {
    modelValue: IArticle;
  }

  interface IEmits {
    (event: 'update:modelValue', modelValue: IArticle): void;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { default: () => getArticleDefaultData() }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({
    (event: 'update:modelValue', modelValue: IArticle): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: IArticle }

  
  

  async function toggleLike() {
    const params = { action_type: 'like', target_type: 'Article', target_id: props.modelValue.id };
    if (props.modelValue.liked) {
      await request.delete('action_stores', { params });
      emits('update:modelValue', {
        ...props.modelValue,
        likes_count: props.modelValue.likes_count - 1,
        liked: false
      });
    } else {
      await request.post('action_stores', params);
      emits('update:modelValue', {
        ...props.modelValue,
        likes_count: props.modelValue.likes_count + 1,
        liked: true
      });
    }
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["like", { active: __props.modelValue.liked }]),
    onClick: toggleLike
  }, [
    _hoisted_1,
    (__props.modelValue.likes_count)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.modelValue.likes_count), 1))
      : _createCommentVNode("", true)
  ], 2))
}
}

})